import { useEffect, useRef, useState } from 'react';

/**
 * Boolean variant of useReveal — returns [ref, inView].
 * Flips `inView` to true once when the element enters the viewport,
 * then disconnects. Use when you need to trigger JS-driven animations
 * (count-ups, staged sequences) rather than just toggling a class.
 */
export default function useInView(options = {}) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (typeof IntersectionObserver === 'undefined') {
      setInView(true);
      return;
    }
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          io.disconnect();
        }
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.2, ...options }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return [ref, inView];
}
